/**
 * Admin Guard
 *
 * Purpose: Protects routes that require admin role
 * Redirects to unauthorized page if user is not admin
 */

import { isAdmin } from '@/core/auth'
import { AuthGuard } from './AuthGuard'
import { AlertCircle } from 'lucide-react'

interface AdminGuardProps {
  children: React.ReactNode
}

export function AdminGuard({ children }: AdminGuardProps) {
  const isUserAdmin = isAdmin()

  return (
    <AuthGuard>
      {isUserAdmin ? (
        <>{children}</>
      ) : (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6 text-center">
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
            <p className="text-gray-600 mb-4">
              You don't have permission to access this page. Admin privileges are required.
            </p>
            <p className="text-sm text-gray-500 mb-4">
              Current user role: {isUserAdmin ? 'admin' : 'user'}
            </p>
            <button onClick={() => window.history.back()} className="btn btn-primary">
              Go Back
            </button>
          </div>
        </div>
      )}
    </AuthGuard>
  )
}
